


































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { ICollabActor } from "../types/actor";
import { serverBase } from "../apollo";

@Component
export default class Collabs extends Vue {
  @Prop(String) name!: string;
  @Prop() collabs!: ICollabActor[];

  showCollabs = false;

  avatarColor(actor: any) {
    if (actor.avatar) return actor.avatar.color || "#ffffff";
    return "#ffffff";
  }

  firstName(name: string) {
    const tokens = name.split(" ");
    if (tokens[0].toLowerCase() == "little") return tokens[1];
    if (tokens.length <= 3) return tokens[0];
  }

  collabAvatar(actor: ICollabActor) {
    if (actor.avatar) {
      return `${serverBase}/media/image/${actor.avatar._id}?password=${localStorage.getItem(
        "password"
      )}`;
    }
    if (actor.thumbnail) {
      return `${serverBase}/media/image/${actor.thumbnail._id}?password=${localStorage.getItem(
        "password"
      )}`;
    }
    return `${serverBase}/broken`;
  }
}
